export const FAQsSection: React.FC<{ data: any; theme: any }> = ({ data, theme }) => {
  if (!data?.questions || data.questions.length === 0) return null;

  return (
    <section id="faqs" className="py-16 sm:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 text-gray-900">
            {data.sectionTitle || "Frequently Asked Questions"}
          </h2>
          {data.description && (
            <p className="text-lg text-gray-600 leading-relaxed">
              {data.description}
            </p>
          )}
        </div>

        <div className="space-y-4">
          {[...data.questions]
            .sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0))
            .map((faq: any, index: number) => (
              <details
                key={index}
                className="group bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow"
              >
                <summary className="px-6 py-5 cursor-pointer font-semibold text-lg text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between">
                  <span className="flex-1">{faq.faqQuestion}</span>
                  <svg
                    className="w-5 h-5 text-gray-500 group-open:rotate-180 transition-transform flex-shrink-0 ml-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </summary>
                <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                  {faq.faqAnswer}
                </div>
              </details>
            ))}
        </div>
      </div>
    </section>
  );
};